import { requireAuthOrProspectEmail } from '../guards';

export const path = '/games/:gameId/bet';
export const component = 'StartGameBetOrder';
export const thunk = () => requireAuthOrProspectEmail;
